var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.25 8.24988H13.8748V9.74964H2.25V8.24988Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M10.6501 14.0253L9.59961 12.9748L13.5751 9.00008L9.59961 5.02532L10.6501 3.97485L15.6746 9.00009L10.6501 14.0253Z","fill":"currentColor","key":1})]);
}

ArrowRight.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
